import request from './request'
import { get, post, del } from './request'

// 查询所有客服账号
export function getKfAccounts() {
  return get('/wework/kf/accounts')
}

// 创建客服账号（name + avatar 文件）
export function createKfAccount(name, avatarFile) {
  const formData = new FormData()
  formData.append('name', name)
  formData.append('avatar', avatarFile)
  return request.post('/wework/kf/accounts', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 修改客服账号
export function updateKfAccount(id, { name, avatarFile }) {
  const formData = new FormData()
  if (name) formData.append('name', name)
  if (avatarFile) formData.append('avatar', avatarFile)
  return request.put(`/wework/kf/accounts/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 删除客服账号
export function deleteKfAccount(accountId) {
  return del(`/wework/kf/accounts/${accountId}`)
}

// 查询客服账号下的接待人员
export function getKfServicers(openKfid) {
  return get('/wework/kf/servicers', { openKfid })
}

// 添加接待人员
export function addKfServicer(openKfid, userId) {
  return post('/wework/kf/servicers', { openKfid, userId })
}

// 移除接待人员
export function removeKfServicer(servicerId) {
  return del(`/wework/kf/servicers/${servicerId}`)
}

// ========== 企业微信绑定 ==========

// 查询用户绑定信息
export function getWeWorkBinding(userId) {
  return get(`/wework/bindings/${userId}`)
}

// 绑定企微账号
export function bindWeWork(data) {
  return post('/wework/bindings', data)
}

// 解绑企微账号
export function unbindWeWork(userId) {
  return del(`/wework/bindings/${userId}`)
}
